export default __webpack_public_path__ + "static/coperta-teaser-noutati-c8a7cca142c575ea230144e1f64808ba.jpg";